<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper" >
            <div class="modal-container" style="max-height:100vh;overflow-y:scroll;">

              <div class="modal-header">
                <slot name="header">
                  Update the fields which need change
                </slot>
              </div>

              <div class="modal-body">
                <slot name="body">
                  Change Location
                  <div class="input-box">
                    <select v-model="passedObject.data.location">
                      <option :key="state.text" v-for="state in states" :value="state.text">
                        {{ state.text }}
                      </option>
                    </select>
                  </div>
                  Change Active status
                  <div class="input-box">
                    <!-- <input type="text" v-model="passedObject.active"> -->
                    <input class="radio-active" type="radio" :value="true" v-model="passedObject.data.active"> <span class="radio-active-span">ACTIVE</span>
                    <input class="radio-active" type="radio" :value="false" v-model="passedObject.data.active"><span class="radio-active-span">INACTIVE</span>
                  </div>
                  Change Targeted Pageviews
                  <div class="input-box">
                    <input type="number" v-model="passedObject.data.pageviews" v-on:change="pvChangeDetected">
                  </div>
                  Change Campaign End Date
                  <div class="input-box">
                     <input type="date" v-model="passedObject.data.endDate" v-on:change="dateChangeDetected">
                  </div>
                  Change Probability
                  <div class="input-box">
                    <input type="number" v-model="passedObject.data.probability" v-on:change="probChangeDetected">
                  </div>
                </slot>
              </div>

              <div class="modal-footer">
                <slot name="footer">
                  <button class="modal-default-button" @click="editBrand">
                    UPDATE ARTICLE
                  </button>
                  <button class="modal-default-button cancel-delete-button" @click="closeTheModal">
                    CANCEL
                  </button>
                </slot>
              </div>
            </div>
            </div>
        </div>
    </transition>
</template>

<script>
import Vue from "vue";
import firebase from 'firebase';
import VueFirestore from "vue-firestore";
require("firebase/firestore");
Vue.use(VueFirestore);
var firestore;
  export default {
    name: 'modal',
    props: {
      passedObject: {
          type: Object
      }
    },
    firestore() {
      return {

      };
    },
    data: function() {
      firestore = firebase.firestore();
      return {
        pvChanged:false,
        dateChanged: false,
        probChanged: false,
        states: [{text: "All States"},{text:"New South Wales"}, {text:"Queensland"}, {text:"South Australia"}, {text:"Victoria"}, {text:"Western Australia"}],
      }
    },
    methods: {
      editBrand() {
        console.log(this.passedObject);
        //Check if we need to re-calculate PROBABILITY
        if(this.pvChanged || this.dateChanged || this.probChanged){
          var currentTotal = 0;
          //Fetch the total of probability for reference
          firestore.collection("brandedArticles").where('active', '==', true).get()
            .then(snapshot => {
              if (snapshot.empty) {
                console.log('No active branded articles found');
              }

              snapshot.forEach(doc => {
                var snapData = doc.data();
                if(snapData.url != this.passedObject.data.url){
                  currentTotal = parseFloat(snapData.probability + currentTotal);
                }
              });
              currentTotal = currentTotal.toFixed(2);
              var maxAllowed = 20 - currentTotal;
              var actualValue = true;
              if(this.pvChanged || this.dateChanged){
                var currentDate = Math.floor(Date.now() / 1000);
                var newDate = new Date(this.passedObject.data.endDate).getTime() / 1000;
                var noOfDays = Math.floor((newDate - currentDate )/ 86400);
                var pvPerDay = this.passedObject.data.pageviews / noOfDays ;
                //The number 900 has been taken based on an estimate of 9,000 available page views for adding branded articles under.
                //This number is roughly 10% of daily pageviews.Can be tweaked if the daily page views change a lot
                var probValue = (pvPerDay / 90).toFixed(2);
                var probNumber = parseFloat(probValue);
                // var totalProb = this.$props.passedValue + probNumber;

                if(probNumber < maxAllowed ){
                  this.passedObject.data.probability = parseFloat(probNumber);
                } else {
                  actualValue = false;
                  this.passedObject.data.probability = parseFloat(maxAllowed);
                }
              } else if (this.probChanged){
                if(this.passedObject.data.probability > maxAllowed){
                  this.passedObject.data.probability = parseFloat(maxAllowed);
                  actualValue = false;
                }
              }
              console.log({
                active: this.passedObject.data.active,
                endDate: this.passedObject.data.endDate,
                pageviews: parseInt(this.passedObject.data.pageviews),
                currentPageviews: parseInt(this.passedObject.data.currentPageviews),
                probability: parseFloat(this.passedObject.data.probability),
                url: this.passedObject.data.url,
                location: this.passedObject.data.location || "All States",
              });
              //Update database after recalculating
              firestore
              .collection("brandedArticles")
              .doc(this.$props.passedObject.id)
              .update({
                active: this.passedObject.data.active,
                endDate: this.passedObject.data.endDate,
                pageviews: parseInt(this.passedObject.data.pageviews),
                currentPageviews: parseInt(this.passedObject.data.currentPageviews),
                probability: parseFloat(this.passedObject.data.probability),
                url: this.passedObject.data.url,
                location: this.passedObject.data.location || "All States",
              });
              if(actualValue){
                alert("Branded article updated");
              }else{
                  alert("Branded article updated.The probabilty value was adjusted as the there are too many competing branded articles. This may not meet its target.");
              }
              this.$emit('update:modal');
            })
            .catch(err => {
              console.log('Error getting branded articles', err);
            });
        } else {
          console.log("2",{
            active: this.passedObject.data.active,
            endDate: this.passedObject.data.endDate,
            pageviews: parseInt(this.passedObject.data.pageviews),
            currentPageviews: parseInt(this.passedObject.data.currentPageviews),
            probability: parseFloat(this.passedObject.data.probability),
            url: this.passedObject.data.url,
            location: this.passedObject.data.location || "All States",
          })
          //Actual update - no recalculation required
          firestore
          .collection("brandedArticles")
          .doc(this.$props.passedObject.id)
          .update({
            active: this.passedObject.data.active,
            endDate: this.passedObject.data.endDate,
            pageviews: parseInt(this.passedObject.data.pageviews),
            currentPageviews: parseInt(this.passedObject.data.currentPageviews),
            probability: parseFloat(this.passedObject.data.probability),
            url: this.passedObject.data.url,
            location: this.passedObject.data.location || "All States",
          });
        alert("Branded article updated");
        this.$emit('update:modal');
        }
    },
    closeTheModal() {
        this.$emit('update:modal');
     },
      dateChangeDetected() {
        this.dateChanged = true;
        console.log('Date change detected');
     },
      pvChangeDetected() {
        this.pvChanged = true;
        console.log('PV change detected');
     },
      probChangeDetected() {
        this.probChanged = true;
        console.log('Prob change detected');
     }
   }
  }
</script>

<style>
.result em {
  background-color: #ccc;
  color:black;
}
.user-edit-screen .md-autocomplete .md-menu input {
  color: black !important;
  -webkit-text-fill-color: black !important;
}
.md-field.md-theme-default:after {
    background-color: rgba(140, 139, 139, 0.7) !important;
}
.md-field.md-theme-default .md-helper-text, .md-field.md-theme-default .md-count, .md-field.md-theme-default label {
    color: rgba(140, 139, 139, 0.7) !important;
}
</style>

<style scoped>
.radio-active {
  width:20px;
}
.radio-active-span {
  margin-right:40px;
}
.flex-row {
  display:flex;
}
input {
  display:block;
}
.cancel-delete-button {
  background-color: #ff5252;
}
.modal-mask {
  overflow-y:scroll;
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}
.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 550px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header{
  color:#000000;
  text-align:center;
}

.modal-body {
  margin: 20px 0;
  color:#000000;
}

.modal-default-button {
  float: right;
}
.modal-footer {
  padding:10px;
}
.modal-footer button {
  margin-right:10px;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}


@media screen and (min-width: $responsive_breakpoint_min) {
  .scrolling-wrapper-flexbox {
    scroll-behavior: smooth;
    overflow-x: hidden;
  }
}
@media screen and (max-width: $responsive_breakpoint_max) {
  .scrolling-wrapper-flexbox {
    overflow-x: scroll;
  }
}
.scrolling-wrapper-flexbox {
    display: flex;
    flex-wrap: nowrap;

    overflow-x:scroll;
    -webkit-overflow-scrolling: touch;
}
input {
      width: 500px;
}
</style>


// WEBPACK FOOTER //
// ModalBrandedit.vue?0a7f35c6